import React from 'react';
const PIXEL_ID = '2209161729849733';
/**
 * Meta (Facebook) Pixel fallback for browsers without JavaScript.
 * The pixel itself is initialized and fires PageView in index.tsx on load.
 */
export function MetaPixel() {
  return <noscript data-id="element-168">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-169" />
    </noscript>;
}